var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#FFF3E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_4440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 27.25C22.2132 27.25 27.25 22.2132 27.25 16C27.25 9.7868 22.2132 4.75 16 4.75C9.7868 4.75 4.75 9.7868 4.75 16C4.75 22.2132 9.7868 27.25 16 27.25Z",
    fill: "url(#paint0_linear_32_4440)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 24.25C20.5563 24.25 24.25 20.5563 24.25 16C24.25 11.4437 20.5563 7.75 16 7.75C11.4437 7.75 7.75 11.4437 7.75 16C7.75 20.5563 11.4437 24.25 16 24.25Z",
    fill: "#FFD39E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32_4440",
    x1: 2.75325,
    y1: 2.18671,
    x2: 33.4157,
    y2: 18.5311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA53D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C36F09"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_4440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.56d3ed1840e1b73fb86f6007a3df5da5.svg";
export { ForwardRef as ReactComponent };